export const { REACT_APP_API_ENDPOINT } = process.env;

export enum REQUEST_STATUS {
	IDLE,
	LOADING,
	SUCCESSED,
	FAILED
}
